import React from 'react';
import { Button, Checkbox, Form, Select } from 'semantic-ui-react';

const SiteDetailsFilters = (props) => {

  const options = [
    { key: "24 hours", text: "24 hours", value: 1 },
    { key: "7 days", text: "7 days", value: 7 },
    { key: "30 days", text: "30 days", value: 30 },
    { key: "60 days", text: "60 days", value: 60 },
    { key: "90 days", text: "90 days", value: 90 },
  ]


  const { onChange, onRefreshClick, selectedPeriod, showEvents, disabled } = props;

  return (
    <Form>
      <Form.Group inline>
        <Form.Field inline>
          <label>Last</label>
          <Select options={options} onChange={onChange} value={selectedPeriod} name="selectedPeriod" />
        </Form.Field>

        <Form.Field inline>
          <Checkbox label="Show Events" onChange={(e) => onChange(e, { name: "showEvents", value: !showEvents })} checked={showEvents} name="showEvents" />
        </Form.Field>

        <Button disabled={disabled} positive onClick={onRefreshClick}>Refresh</Button>
      </Form.Group>
    </Form>
  )
}

export default SiteDetailsFilters;